import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Custom verified badge with checkmark — replaces Check/CheckCircle */
export function IconVerified({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Rounded badge shape */}
      <path d="M12 2L14.4 4.2L17.5 3.5L18 6.6L21 8L19.8 11L21 14L18 15.4L17.5 18.5L14.4 17.8L12 20L9.6 17.8L6.5 18.5L6 15.4L3 14L4.2 11L3 8L6 6.6L6.5 3.5L9.6 4.2L12 2Z" />
      {/* Checkmark */}
      <path d="M8.5 11.5L11 14L16 9" strokeWidth="2" />
    </svg>
  );
}
